import { module } from 'angular';

import { CsvImportDirective, default as csvImportDirectiveName } from './csv-import.directive';

export default module('contact.commons.toolbox.csv-import', []).directive(csvImportDirectiveName, CsvImportDirective).name;
